import { useAuth0 } from "@auth0/auth0-react";
import React, { useEffect } from "react";
import { clearAllState } from "../state/utils/localStorage";
import { getNewSiteBaseUrl } from "../data/newSiteConfig";
import "tailwindcss/tailwind.css";

const Logout = () => {
  const { logout } = useAuth0();

  useEffect(() => {
    // Clear ayana_auth cookie on .ayana.com
    document.cookie =
      "ayana_auth=; domain=.ayana.com; path=/; secure; SameSite=Lax; expires=Thu, 01 Jan 1970 00:00:00 GMT";

    // Clear local Auth0/app state (localStorage)
    clearAllState();

    // Redirect to Auth0 logout, then to the new Astro site
    logout({
      logoutParams: {
        federated: false,
        returnTo: `${getNewSiteBaseUrl()}/rewards/`,
      },
      clientId: process.env.GATSBY_AUTH0_CLIENT_ID,
    });
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
      }}>
      <div
        className="tw-flex tw-flex-col tw-items-center tw-justify-center"
        style={{ gap: "1rem" }}>
        <div
          className="tw-flex tw-flex-col tw-items-center"
          style={{ gap: "1rem" }}>
          <div className="tw-animate-pulse tw-transform">
            <img
              src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/AYANA_Rewards_logo_2023_6baf3ef4d3.png"
              className="tw-max-w-[120px]"
              alt="ayana-rewards-logo"
            />
          </div>
        </div>
        <p className="tw-text-[20px] tw-leading-[28px] tw-opacity-50 tw-animate-pulse tw-font-serif">
          Signing out...
        </p>
      </div>
    </div>
  );
};

export default Logout;
